import { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { useAppStore } from 'src/context/AppStore';
import { observer } from 'mobx-react-lite';

interface BaseLayoutProps {
  children?: ReactNode;
}

const BaseLayout: FC<BaseLayoutProps> = ({ children }) => {
  const { isPersisting } = useAppStore();
  return <> {isPersisting && (children || <Outlet />)} </>;
};

BaseLayout.propTypes = {
  children: PropTypes.node
};

export default observer(BaseLayout);
